export type Mode = 'practice' | 'challenge';
export type Status = 'ready' | 'running' | 'paused' | 'over' | 'won';
export const GROUND = 238;
export const PLAYER_X = 72;
export const PLAYER_WIDTH = 32;
export const PLAYER_HEIGHT = 43;
const GRAVITY = 1600;
const JUMP_SPEED = 570;
export const PRACTICE_GOAL = 10;
export type Obstacle = { x: number; width: number; height: number; signaled: boolean; counted: boolean };
export type GameState = {
  status: Status; mode: Mode; width: number; height: number; velocity: number;
  elapsed: number; score: number; speed: number; spawnIn: number; spawned: number;
  obstacles: Obstacle[]; pulse: number; leadMs: number;
};
export function createGame(mode: Mode = 'practice', width = 900, leadMs = 350): GameState {
  return { status: 'ready', mode, width, height: 0, velocity: 0, elapsed: 0, score: 0,
    speed: 240, spawnIn: 2.1, spawned: 1, leadMs, pulse: 0,
    obstacles: [{ x: Math.max(width, 550), width: 24, height: 42, signaled: false, counted: false }] };
}
export function jump(game: GameState): boolean {
  if (game.status !== 'running' || game.height > 0) return false;
  game.velocity = JUMP_SPEED;
  game.height = .01;
  return true;
}
export function step(game: GameState, seconds: number) {
  if (game.status !== 'running') return;
  // The caller uses a fixed time step; cap standalone calls to avoid teleporting on long frames.
  const dt = Math.max(0, Math.min(seconds, 1 / 60));
  game.elapsed += dt;
  game.speed = game.mode === 'practice' ? 240 : Math.min(410, 240 + game.score * 6);
  game.height = Math.max(0, game.height + game.velocity * dt);
  if (game.height > 0) game.velocity -= GRAVITY * dt;
  else game.velocity = 0;
  game.pulse = Math.max(0, game.pulse - dt);
  game.spawnIn -= dt;
  if (game.spawnIn <= 0) {
    const shape = game.spawned % 3;
    game.obstacles.push({ x: game.width + 45, width: shape === 2 ? 37 : 24, height: shape === 1 ? 50 : 42, signaled: false, counted: false });
    game.spawned += 1;
    game.spawnIn = [2.2, 2.5, 2.05][game.spawned % 3];
  }
  for (const obstacle of game.obstacles) {
    obstacle.x -= game.speed * dt;
    const timeToPlayer = (obstacle.x - (PLAYER_X + PLAYER_WIDTH - 5)) / game.speed;
    if (!obstacle.signaled && timeToPlayer <= game.leadMs / 1000 && timeToPlayer > 0) {
      obstacle.signaled = true;
      game.pulse = .12;
    }
    const overlapsX = PLAYER_X + PLAYER_WIDTH - 5 > obstacle.x + 3 && PLAYER_X + 5 < obstacle.x + obstacle.width - 3;
    if (overlapsX && game.height + 5 < obstacle.height) {
      game.status = 'over'; game.pulse = 0; return;
    }
    if (!obstacle.counted && obstacle.x + obstacle.width < PLAYER_X) {
      obstacle.counted = true;
      game.score += 1;
      if (game.mode === 'practice' && game.score >= PRACTICE_GOAL) {
        game.status = 'won'; game.pulse = 0; return;
      }
    }
  }
  game.obstacles = game.obstacles.filter(obstacle => obstacle.x > -80);
}
